import {Observable} from 'rxjs/Observable';
import FileStackClient from 'utils/filestack';
import {tempStoreOptions} from "./utils";

export function doResizeImage(observer, file, width, height, fit = "clip") {
    let options = {
        resize: {
            // No decimals allowed
            width: Math.round(width),
            height: Math.round(height),
            fit: fit
        }
    };

    // transform image at given url and then store the transformed image in temp storage
    let newUrl = FileStackClient.transform(file.url, options);

    FileStackClient.storeURL(newUrl, tempStoreOptions).then((result) => {
        try {
            observer.next(result);
        } catch (err) {
            observer.error(err);
            return;
        }

        observer.complete();
    }).catch((reason) => {
        observer.error(reason);
    });
}

export function resizeImage(width, height, fit) {
    return (source) => Observable.create((observer) => {
        source.subscribe(
            (file) => doResizeImage(observer, file, width, height, fit),
            (err) => observer.error(err),
            () => observer.complete()
        );
    })
}

// just upload an image without any transformation
export function doStoreImage(observer, file) {
    console.log(`doStoreImage`)

    FileStackClient.storeURL(file.url, tempStoreOptions).then((result) => {
        try {
            observer.next(result);
        } catch (err) {
            observer.error(err);
            return;
        }

        observer.complete();
    }).catch((reason) => {
        observer.error(reason);
    });
}



// WEBPACK FOOTER //
// ./public/observables/lettables/resizeImage.js